export { FAQSection } from "./faq-section";
